import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Tabs, getColor, Icons, Typography } from "fds";
import "./index.scss";
import { DocInfo, DocumentListReq, DocumentListResp } from "../../types/files";
import DocumentBottom from "../../components/DocumentBottom";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import { useNavigate } from "react-router-dom";
import WorkgroupAddModal from "../../components/WorkgroupAddModal";
import utilsCommon from "../../shared/utils/common";
import { t } from "i18next";
interface IProps {
  tab: number;
}
const MyInbox: React.FC<IProps> = ({ tab }) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";
  const navigate = useNavigate();
  const { documentState, getContentList } = useDocumentStore();

  const [openExtraModal, changeOpenExtraModal] = useState("CLOSE");
  const [docInfo, changeDocListInfo] = useState<DocumentListResp>();
  const [filter, changeFilters] = useState<DocumentListReq>({
    page: 0,
    size: 50,
    order: "datedesc",
    search: "",
    readType: "",
    masterUserId: "",
    tagCodes: ["NONEWORKGROUP"],
    date: {
      start: 0,
      end: 0,
    },
    folderCode: "",
  });
  useEffect(() => {
    if (filter?.masterUserId === "") return;
    getContentList(filter);
  }, [filter]);
  useEffect(() => {
    if (tab === 1 && loginDto?.ecoUserInfo?.userType !== 1) {
      navigate(`${process.env.PUBLIC_URL}/myInbox/received`);
    } else
      changeFilters({
        page: 0,
        size: 50,
        order: "datedesc",
        search: "",
        readType: "",
        masterUserId: tab === 0 ? "-1" : myId,
        tagCodes: ["NONEWORKGROUP"],
        date: {
          start: 0,
          end: 0,
        },
        folderCode: "",
      });
  }, [tab]);
  useEffect(() => {
    changeDocListInfo(documentState.docListInfo);
  }, [documentState.docListInfo]);

  const changeFilterByKey = (key: string, value: any) => {
    let newValue = value;
    if (key === "order") {
      if (value.includes("_direct")) {
        newValue = value.split("_direct")[0];
      } else {
        if (value === "file") {
          if (filter?.order.includes("date")) {
            newValue = "filedesc";
          } else {
            newValue = filter?.order === "filedesc" ? "file" : "filedesc";
          }
        } else {
          if (filter?.order.includes("file")) {
            newValue = "datedesc";
          } else {
            newValue = filter?.order === "datedesc" ? "date" : "datedesc";
          }
        }
      }
      document.getElementById("docTable")?.scrollTo(0, 0);
    } else if (
      key === "page" &&
      (!docInfo?.docs?.doc || docInfo?.total === docInfo?.docs?.doc?.length)
    ) {
      return;
    }
    changeFilters({
      ...filter,
      [key]:
        typeof newValue === "string"
          ? newValue.replace("name", "file")
          : newValue,
      page: key === "page" ? value : 0,
    });
  };

  return (
    <Box width={"100%"} height={"100%"} classes={"myInbox body"} key={tab}>
      {["SEND_FILE"].includes(openExtraModal) && (
        <WorkgroupAddModal
          createType={"SEND_FILE"}
          open
          onClose={() => changeOpenExtraModal("CLOSE")}
          onSubmitAfter={() => getContentList(filter)}
        />
      )}
      <Box height={96} classes={"layout-title"}>
        <Typography type="h1">My Box</Typography>
        {utilsCommon.checkVisibleOptions("sendFile") && (
          <Button
            label={t("sendingFile.title")}
            size={"lg"}
            leadingIcon={<Icons variant="line" label="send" />}
            btnStyle={"fill"}
            type={"secondary"}
            onClick={() => changeOpenExtraModal("SEND_FILE")}
          />
        )}
      </Box>
      <Tabs
        type={"leftFull"}
        selectTab={(tab) => {
          navigate(
            tab === 0
              ? `${process.env.PUBLIC_URL}/myInbox/received`
              : `${process.env.PUBLIC_URL}/myInbox/sent`
          );
        }}
        selected={tab}
        size={"lg"}
        paddingLeft={32}
        tabs={[t("sendingFile.received"), t("sendingFile.send")]
          .filter(
            (item1, idx) =>
              !(loginDto?.ecoUserInfo?.userType !== 1 && idx !== 0)
          )
          .map((item) => {
            return { text: item, color: "default" };
          })}
        classes={"mg mb-12"}
      />
      <DocumentBottom
        filter={filter}
        docInfo={docInfo}
        changeFilterByKey={changeFilterByKey}
        height={"calc(100% - 145px)"}
        listTableHeight={"calc(100vh - 304px)"}
        cardTableHeight={"calc(100vh - 305px)"}
        endReached={() => changeFilterByKey("page", filter.page + 1)}
        isInitFilter
        page={tab === 0 ? "receivedFile" : "sendFile"}
      />
    </Box>
  );
};

export default MyInbox;
